import { useState } from "react";
import { productionGateway } from "../production-gateway";

export type TerminalEnrollmentProps = { terminalCode: string; error: string | null; onEnrolled: () => Promise<void>; onBack?: () => void };

export function useTerminalEnrollmentWorkspace({ terminalCode, error, onEnrolled }: TerminalEnrollmentProps) {
  const [enrollmentCode, setEnrollmentCode] = useState("");
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(error);
  const submit = async () => {
    if (enrollmentCode.trim().length < 24) { setMessage("Geçerli terminal kayıt anahtarını girin."); return; }
    setSaving(true);
    try { await productionGateway.enrollTerminal(terminalCode, enrollmentCode.trim()); setEnrollmentCode(""); await onEnrolled(); }
    catch (nextError) { setMessage(nextError instanceof Error ? nextError.message : "Terminal kaydı doğrulanamadı."); }
    finally { setSaving(false); }
  };
  return { enrollmentCode, setEnrollmentCode, saving, message, submit };
}
